//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import {
  IPartialState,
  NavGroup,
  StateFactory,
} from 'app/initialization/routing/stateHelpers';

// Sets default values for state data
export function CampaignsStateFactory(state: IPartialState) {
  const accessFn = state.data?.hasAccess ?? (() => true);
  const data = {
    title: 'Campaigns',
    navGroup: NavGroup.CAMPAIGNS,
    ...state.data,
    hasAccess: () => accessFn(),
  };

  return StateFactory({
    ...state,
    data,
  });
}
